module.exports = __webpack_public_path__ + "img/objective_statement.d7262a23.png";